<template>
    <template v-if="signInMethod.oktaEnabled" >
        <sign-in-okta  />
    </template>
    <template v-if="signInMethod.formEnabled">
        <sign-in-form  />
    </template>
    <template v-if="signInMethod.codeEnabled" >
        <sign-in-code />
    </template>
</template>

<script setup lang="ts">

    definePageMeta({ layout: 'default-no-header' });

    const {signInMethod} = useAppConfig();
</script>